// extracted by mini-css-extract-plugin
export var card = "_v2-0";